// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".foaps-app-bar .v-toolbar__content{padding:0}.foaps-app-bar .v-btn--active{background-color:#fff!important;color:transparent!important}.foaps-app-bar .v-btn--active .v-btn__content{color:#ff6648!important}.foaps-app-bar .border-right{border-right:2px solid #b0b0b0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
